import React, { useMemo, useState } from "react"
import { connect } from "react-redux"
import PropTypes from "prop-types"
import * as serviceActions from "../../store/servicesManagment/actions"
import TableContainer from "components/Common/TableContainer"
import { Name } from "./AccCol"
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Table } from "reactstrap"
import moment from "moment";
import { doc, getDoc } from "firebase/firestore"; // Import Firebase methods
import { db } from "../../helpers/firebase/firebaseConfig"; // Import your Firebase config
import "./ServiceRatings.scss"
import ServiceCommentsCard from "./ServiceCommentsCard";







const getRatingSummary = (serviceRates = []) => {
  const ratings = Array.isArray(serviceRates)
    ? serviceRates
      .map(Number)
      .filter(
        (rating) =>
          Number.isInteger(rating) &&
          rating >= 1 &&
          rating <= 5
      )
    : [];

  const total = ratings.length;

  const breakdown = [5, 4, 3, 2, 1].map((stars) => ({
    stars,
    count: ratings.filter((rating) => rating === stars).length,
  }));

  const average =
    total > 0
      ? ratings.reduce((sum, rating) => sum + rating, 0) / total
      : 0;

  return { total, average, breakdown };
};




const ServiceRatingsCard = ({ serviceRates }) => {
  const { total, average, breakdown } =
    getRatingSummary(serviceRates);

  return (
    <div className="service-ratings-card" dir="rtl">
      <div className="service-ratings-header">
        <div>
          <h5 className="mb-1">تقييمات الخدمة</h5>
          <p className="service-ratings-subtitle mb-0">
            تقييمات العملاء ومستوى رضاهم عن الخدمة
          </p>
        </div>

        <div className="service-ratings-icon">
          <i className="bx bxs-star" />
        </div>
      </div>

      {total === 0 ? (
        <div className="service-ratings-empty">
          <i className="bx bx-message-square-dots" />
          <h6>لا توجد تقييمات حتى الآن</h6>
          <p className="mb-0">
            ستظهر التقييمات هنا عند تقييم العملاء للخدمة.
          </p>
        </div>
      ) : (
        <>
          <div className="service-rating-overview">
            <div className="service-rating-score">
              <strong>{average.toFixed(2)}</strong>

              <div
                className="service-rating-stars"
                aria-label={`${average.toFixed(2)} من 5`}
              >
                {[1, 2, 3, 4, 5].map((star) => (
                  <i
                    key={star}
                    className={`bx ${average >= star
                        ? "bxs-star"
                        : average >= star - 0.5
                          ? "bxs-star-half"
                          : "bx-star"
                      }`}
                  />
                ))}
              </div>

              <span>{total} تقييم</span>
            </div>

            <div className="service-rating-breakdown">
              {breakdown.map(({ stars, count }) => (
                <div className="service-rating-row" key={stars}>
                  <span className="service-rating-label">
                    {stars}
                    <i className="bx bxs-star" />
                  </span>

                  <div
                    className="service-rating-progress"
                    role="progressbar"
                    aria-valuenow={count}
                    aria-valuemin={0}
                    aria-valuemax={total}
                    aria-label={`${stars} نجوم: ${count} تقييم`}
                  >
                    <div
                      className="service-rating-progress-fill"
                      style={{
                        width: `${(count / total) * 100}%`,
                      }}
                    />
                  </div>

                  <span className="service-rating-count">
                    {count}
                  </span>
                </div>
              ))}
            </div>
          </div>

          <div className="service-ratings-footer">
            <i className="bx bx-check-circle" />
            <span>
              إجمالي التقييمات: {total}
            </span>
          </div>
        </>
      )}
    </div>
  );
};









const ServiceList = ({ services, handleEditService, handleRemoveService }) => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [service, setService] = useState(null)
  const [isImageModalOpen, setIsImageModalOpen] = useState(false)
  const [imageUrl, setImageUrl] = useState("")

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen)
  }

  const toggleImageModal = () => {
    setIsImageModalOpen(!isImageModalOpen)
  }
  const fetchProviderDetails = async (providerId) => {
    try {
      const providerDoc = await getDoc(doc(db, "service_providers", providerId));
      if (providerDoc.exists()) {
        return providerDoc.data();
      } else {
        console.error("No provider found with the given ID");
        return null;
      }
    } catch (error) {
      console.error("Error fetching provider details:", error);
      return null;
    }
  };
  const moreDetails = async (data) => {
    const providerDetails = await fetchProviderDetails(data.service_provider_id);
    setService({
      ...data,
      serviceProviders: providerDetails, // Add provider details to the service object
    });
    toggleModal();
  };

  const openImageModal = url => {
    setImageUrl(url)
    toggleImageModal()
  }



  ServiceRatingsCard.propTypes = {
    serviceRates: PropTypes.array,
  };

  ServiceRatingsCard.defaultProps = {
    serviceRates: [],
  };

  ServiceRatingsCard.propTypes = {
    serviceRates: PropTypes.array,
  };

  ServiceRatingsCard.defaultProps = {
    serviceRates: [],
  };



  const columns = useMemo(
    () => [
      {
        Header: "  اسم الخدمة",
        accessor: "name",
        disableFilters: false,
        filterable: true,
        Cell: cellProps => <Name {...cellProps} />,
      },
      {
        Header: " قسم الخدمة",
        accessor: "service_category",
        disableFilters: false,
        filterable: true,
        Cell: cellProps => <Name {...cellProps} />,
      },
      {

        accessor: "more",
        disableFilters: true,
        Cell: ({ row }) => (
          <Button onClick={() => moreDetails(row.original)}>
            عرض التفاصيل
          </Button>
        ),
      },
      {

        accessor: "delete",
        disableFilters: true,
        Cell: ({ row }) => (
          <Button
            color="danger"
            onClick={() => handleRemoveService(row.original)}
          >
            حذف

          </Button>
        ),
      },
      {
        accessor: "edit",
        disableFilters: true,
        Cell: ({ row }) => (
          <Button
            color="primary"
            onClick={() => handleEditService(row.original)}
          >
            تعديل
          </Button>
        ),
      },

    ],
    []
  )

  return (

    <>

      <TableContainer
        columns={columns}
        data={services || []}
        isGlobalFilter={false}
        customPageSize={5}
        customPageSizeOptions={true}
      />
      <DiscriptionModal
        isOpen={isModalOpen}
        toggleModal={toggleModal}
        service={service}
        openImageModal={openImageModal}
      />
      <ImageModal
        isOpen={isImageModalOpen}
        toggleModal={toggleImageModal}
        imageUrl={imageUrl}
      />
    </>


  )
}

ServiceList.propTypes = {
  services: PropTypes.array.isRequired,
  handleEditService: PropTypes.func.isRequired,
  handleRemoveService: PropTypes.func.isRequired,
}

const mapStateToProps = state => ({
  services: state.service.services,
})

const DiscriptionModal = ({ isOpen, toggleModal, service, openImageModal }) => {
  if (!service) {
    return null; // Return null if no order data is available
  }
  return (
    <Modal isOpen={isOpen} toggle={toggleModal}>
      <ModalHeader toggle={toggleModal}>تفاصيل الخدمة</ModalHeader>
      <ModalBody>
        <p className="mb-2">
          <strong>تاريخ التسجيل:</strong>{" "}
          <span className="text-primary">
            {moment(service.booking_execute_date).format("DD MMMM, YYYY")}
          </span>
        </p>
        <p className="mb-2 ">
          <strong className="m-3"> قسم الخدمة :</strong>
          <span>
            {service.service_category}
          </span>
        </p>

        <hr />



        <div className="table-responsive">
          <Table className="table align-middle table-nowrap">
            {/* Keep your existing service details rows */}
          </Table>
        </div>

        <div className="table-responsive">
          <Table className="table align-middle table-nowrap">
            <tbody>
              <tr>
                <td>
                  <strong>اسم الخدمة :</strong>
                </td>
                <td> {service.name}</td>
              </tr>


              <tr>
                <td>
                  <strong>  سعر خدمة البرنامج:</strong> </td>
                <td>{service.service_price} </td>

              </tr>

              <tr>
                <td>
                  <strong>  سعر الخدمة في المنزل :</strong>
                </td>
                <td>{service.at_home_service_cost}</td>
              </tr>
              <tr>
                <td>
                  <strong>  نوع الخدمة :</strong>
                </td>
                <td>{service.service_type}</td>
              </tr>
              <tr>
                <td>
                  <strong>   الوصف:</strong>
                </td>
                <td>{service.description}</td>
              </tr>
              <tr>
                <td>
                  <strong>متوسط وقت التنفيذ:</strong>
                </td>
                <td>
                  {service.avg_execute_time >= 60
                    ? `${(service.avg_execute_time / 60).toFixed(2)} ساعة`
                    : `${service.avg_execute_time} دقيقة`}
                </td>
              </tr>


              <tr>
                <td>
                  <strong>مقدم الخدمة:</strong>
                </td>
                <td style={{ direction: "ltr" }}>
                  {service.serviceProviders?.full_name ?? "غير متوفر"}
                </td>
              </tr>
              <tr>
                <td>
                  <strong>رقم الهاتف مقدم الخدمة:</strong>
                </td>
                <td style={{ direction: "ltr" }}>
                  {service.serviceProviders?.mobile ?? "غير متوفر"}
                </td>
              </tr>


              <tr>
                <td>
                  <strong>  صورة الخدمة:</strong>
                </td>
                <td>
                  {service.img_url ? (
                    <img
                      src={service.img_url}
                      alt={`Image`}
                      style={{ width: "50px", height: "50px" }}
                      onClick={() => openImageModal(service.img_url)}
                    />
                  ) : (
                    <img
                      src={"./images/noimg.jpg"}
                      alt={`Image`}
                      style={{ width: "100px", height: "100px" }}
                      onClick={() => openImageModal("./images/noimg.jpg")}
                    />
                  )}
                </td>
              </tr>

            </tbody>

          </Table>

        </div>

        <hr />

        <ServiceRatingsCard
          serviceRates={service.service_rates}
        />

        <ServiceCommentsCard
          serviceComments={service.service_comments}
        />

      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={toggleModal}>
          إغلاق
        </Button>
      </ModalFooter>
    </Modal>
  )
}

const ImageModal = ({ isOpen, toggleModal, imageUrl }) => (
  <Modal isOpen={isOpen} toggle={toggleModal} size="lg">
    <ModalHeader toggle={toggleModal}>صورة الخدمة</ModalHeader>
    <ModalBody>
      <img src={imageUrl} alt="Service" style={{ width: "100%" }} />
    </ModalBody>
    <ModalFooter>
      <Button color="primary" onClick={toggleModal}>
        إغلاق
      </Button>
    </ModalFooter>
  </Modal>
)
const translations = {
  at_home: "المنزل",
  at_center: "المركز",
  both: "كلاهما",
};

export default connect(mapStateToProps, serviceActions)(ServiceList)





